import { createApiInstance } from './axios-config';

/**
 * Knowledge API Service
 *
 * Provides methods for semantic search and knowledge graph operations.
 */
class KnowledgeApiService {
  private readonly axios = createApiInstance();

  /**
   * Semantic search for messages and other content
   * @param agentId - The agent ID to search within
   * @param query - The search query
   * @param options - Search options
   */
  async semanticSearch(
    agentId: string,
    query: string,
    options?: {
      nodeTypes?: string[];
      limit?: number;
      minScore?: number;
    }
  ): Promise<{
    results: Array<{
      uid: string;
      score: number;
      nodeType: string;
      conversationId?: string;
      content?: string;
      [key: string]: any;
    }>;
  }> {
    const response = await this.axios.post(`/api/v1/agents/${agentId}/knowledge-search`, {
      query,
      nodeTypes: options?.nodeTypes,
      limit: options?.limit || 50,
      minScore: options?.minScore || 0.0,
    });

    return response.data;
  }
}

// Export singleton instance
export const knowledgeApi = new KnowledgeApiService();

// Export class for testing
export default KnowledgeApiService;
